const ACTIVE = 'ACTIVE';
const INACTIVE = 'INACTIVE';
const UPCOMING = 'UPCOMING';

export default {
  ACTIVE,
  INACTIVE,
  UPCOMING,
};
